import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as HotSpotsActions from './hot-spots.actions';

import { PreferredLocationService } from '@cpd-app/core-module/services';
import { OccupationDetailFacade } from '../occupation-detail/occupation-detail.facade';

@Injectable()
export class HotSpotsEffects {
  constructor(
    private actions$: Actions,
    private preferredLocationService: PreferredLocationService,
    private occupationDetailFacade: OccupationDetailFacade
  ) {}

  putPreferredLocation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(HotSpotsActions.putPreferredLocation),
      switchMap((action) => {
        return this.preferredLocationService
          .putPreferredLocation(action.locationModel)
          .pipe(
            map((data) =>
              HotSpotsActions.putPreferredLocationSuccess({ data })
            ),
            catchError((error) =>
              of(HotSpotsActions.putPreferredLocationError({ error }))
            )
          );
      })
    );
  });

  searchLocations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(HotSpotsActions.searchLocations),
      switchMap(({ searchTerm }) => {
        return this.preferredLocationService.searchLocations(searchTerm).pipe(
          map((data) => HotSpotsActions.receivedLocationsListSuccess({ data })),
          catchError((error) =>
            of(HotSpotsActions.loadLocationsListFailure({ error }))
          )
        );
      })
    );
  });

  getHotspots$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(HotSpotsActions.getHotspots),
      switchMap(() => this.occupationDetailFacade.occupationDetail$),
      switchMap((occupation) => {
        if (occupation) {
          return of(
            occupation['hotSpots']?.map((item) => ({
              ...item,
              salary: item.salary ? Number(item.salary) : 0,
              salaryText: item.salary
                ? '$' + Number(item.salary).toLocaleString('us')
                : 'N/A',
              z: Number(item?.salary) || 0
            }))
          );
        }

        return of([]);
      }),
      map((data) => HotSpotsActions.getHotSpotsSuccess({ data })),
      catchError((error) => of(HotSpotsActions.getHotSpotsFailure({ error })))
    );
  });

  deletePreferredLocation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(HotSpotsActions.deletePreferredLocation),
      switchMap((action) => {
        return this.preferredLocationService
          .deletePreferredLocation(action.locationModel)
          .pipe(
            map((data) =>
              HotSpotsActions.deletePreferredLocationSuccess({ data })
            ),
            catchError((error) =>
              of(HotSpotsActions.deletePreferredLocationError({ error }))
            )
          );
      })
    );
  });
}
